import { reactive, readonly, toRefs } from 'vue'
import { httpInstance } from './http'
import { setProducts } from './product'
import { setTransport } from './transport'

const state = reactive({
  bonusCode: null,
  isValid: true,
})

export function setBonusCode(code) {
  state.bonusCode = code
  state.isValid = true
}

export const bonusCode = readonly(toRefs(state).bonusCode)

export async function updateBonusCode(code) {
  if (!code) {
    return false
  }

  try {
    const {
      data: { items, transport, success },
    } = await httpInstance.post('setBonusCode', {
      code,
    })

    state.bonusCode = code
    state.isValid = success

    setProducts(items || [])
    setTransport(transport || [])
  } catch (error) {
    console.error(error)
  }
}

export async function removeBonusCode() {
  try {
    const {
      data: { items, transport },
    } = await httpInstance.post('removeBonusCode')

    state.bonusCode = null
    state.isValid = false

    setProducts(items || [])
    setTransport(transport || [])
  } catch (error) {
    console.error(error)
  }
}

export const isBonusCodeValid = readonly(toRefs(state).isValid)
